/* ------------ -------------- ------------*/
/* ------------  Warn Form  ---------------*/
/* ------------ -------------- ------------*/


export default (values)=> {

    const warnings = { }
    if (values.age < 19) {
        warnings.age = 'Hmm, you seem a bit young...'
    }
    return warnings
}